import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CContainer,
	CRow,CCol,
	CForm,CFormInput,CInputGroup,CInputGroupText,CFormSelect,
	CButton,
	CImage,
	CCard,CCardHeader,CCardFooter,CCardBody,
	CLink,
} from '@coreui/react';
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import {
	MyDialogform,
	MyPagination,
	MyPage500,
} from '../components/index'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { UFunc,cBulanPanjang,cBulanPendek } from '../helpers/functions'
import { Konfirm } from '../helpers/onConfirm';

const pjson 	= require('../../package.json')
const Lappyad 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaObj  			= useSelector(state => state.listBahasa);
	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const uIsScrollBottom		= useSelector(state => state.gIsScrollBottom);
	const uSettinguserObj		= useSelector(state => state.gListUserSetting);
	const uSettingsystemObj		= useSelector(state => state.gSystemsetting);
	const uHTMLstyleTabel		= useSelector(state => state.gHTMLstyleLaporan);
	const [uEfekview,setEfekview]= React.useState(false);

	const uSidebarUnfoldable 	= useSelector((state) => state.sidebarUnfoldable)// || true;
	const uSidebarshow			= useSelector((state) => state.sidebarShow);

	const uIsAllowedhapus		= uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"
	const uMaxData				= isMobile ? (uSettinguserObj.jml_mobile || 20) : (uSettinguserObj.jml_laporan || 100);
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelView 			= uHeaderActionObj.isHeaderView || false;
	const uHandelReset	 		= uHeaderActionObj.isHeaderReset || false;

	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uDatavieworiArr,setDatavieworiArr]= React.useState([]);
	const [uDataviewArr,setDataviewArr]		= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);
	const [uDataloadedObj,setDataloadedObj]	= React.useState();
	const [uTitelObj,setTitelObj]			= React.useState({});
	const [uDataidentitasObj,setDataidentitasObj]	= React.useState({});
	const [uSortedObj,setSortedObj]			= React.useState({});
	const [uISShowtheadfixed,setShowtheadfixed]	= React.useState(false);

	//---DLGFORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	//---END DLGFORM--/

	//--DOM_ELEMENTS--/
	const uElJmldata	= document.getElementById("idjmldata");
	const uFrameExport 	= document.getElementById("ifmcontentstoprint");
	const fileType 		= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";

	const tableRef 			= React.useRef(null);
	const headerRef 		= React.useRef(null);
	const scrollContainerRef= React.useRef(null);
	const fixedElementRef 	= React.useRef(null);

	const uCardmainwidth	= document.getElementById("idcardmain") &&
		document.getElementById("idcardmain").offsetWidth;
	const uHeaderpageheight	= document.getElementById("idheaderpage") && 
		document.getElementById("idheaderpage").offsetHeight;
	const uSidebar	= document.getElementById("idsidebarmain");

	const uScreenwidth		= window.outerWidth;
	const uTablewidth 		= uCardmainwidth < 2150 ? (uScreenwidth < 1000 ? 1900 : 2150) : uCardmainwidth;
	const uStylekolfixed	= {
		position: "sticky",
		left: 0,
		backgroundColor:"#f0f0f0",
		zIndex: 1,
	}

	//--END DOM_ELEMENTS--/

	//---HANDLE--/
	const hdlDlgformToggle = () => { setDlgformshow(false) }
	const hdlKlikDlgformsimpan = () => {
		let vElfocus	= document.getElementById("inpbulanid");
		if((parseInt(uDlgformObj.bln_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Periode Bulan Tidak Valid !"); return
		} 
		vElfocus	= document.getElementById("inptahun");
		if((parseInt(uDlgformObj.tahun)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Periode Tahun Tidak Valid !"); return
		} 
		vElfocus	= document.getElementById("inpbulanid");
		const vTanggalpilihDT = UFunc.toDate(uDlgformObj.tahun+"-"+UFunc.leadZero(uDlgformObj.bln_id)+"-01");
		if(UFunc.DateIsBeyond(vTanggalpilihDT)) {
			vElfocus && vElfocus.focus();
			showToast("Periode Bulan/Tahun Tidak Valid !"); return
		}

		apiLoadview();
	}
	const hdlKlikCetak = () => {
		if(uJmlData <= 0) return;

		let vContent 	= contentHTMLcetak();
		let pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.focus();
		pri.print();
	}
	const hdlKlikExcel = () => {
		if(uJmlData <= 0) return;

		contentExcel();
	}
	const handleScrollwindow = () => {
		const table			= tableRef.current;
		const tableheader 	= headerRef.current;

		if (!table || !tableheader) return;

		const tableTop 		= table.getBoundingClientRect().top;
		const tableBottom 	= table.getBoundingClientRect().bottom;
		const tHeaderheight = tableheader.offsetHeight;

		//console.log("(Lappyad - handleScrollwindow) tableTop:", tableTop);
		//console.log("(Lappyad - handleScrollwindow) tableBottom:", tableBottom);
		//console.log("(Lappyad - handleScrollwindow) tHeaderheight:", tHeaderheight);
		//console.log("(Lappyad - handleScrollwindow) uHeaderpageheight-tHeaderheight:", (uHeaderpageheight-tHeaderheight));

		if (tableTop <= uHeaderpageheight-tHeaderheight && tableBottom > tHeaderheight) {
			setShowtheadfixed(true);
		} else {
			setShowtheadfixed(false);
		}
	}
	const handleScrolltabel  = () => {
		if (scrollContainerRef.current && fixedElementRef.current) {
			const scrollLeft = scrollContainerRef.current.scrollLeft;
			//console.log("(Lappyad - handleScrolltabel) scrollLeft:", scrollLeft);
			fixedElementRef.current.scrollLeft = scrollLeft;
		}
	}
	const handleScrolltabelfixed  = () => {
		if (scrollContainerRef.current && fixedElementRef.current) {
			const scrollLeft = fixedElementRef.current.scrollLeft;
			scrollContainerRef.current.scrollLeft = scrollLeft;
		}
	}
	//---END HANDLE--/

	//---PROSES--/
	const initJmldata = () => {
		uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
	}
	//---END PROSES--/

	//---CONTENT--/
	const contentThead = () => {
		if(uHTMLError500 || uJmlData <= 0) return "";

		return (
			<tr className="text-center align-top classfontsmaller bg-light">
			<th width={35} className="border" style={uStylekolfixed}>No</th>
			<th className="text-start border" style={{...uStylekolfixed,left:35,minWidth:200}}>{uBahasaObj.word_customer||"Customer"}</th>
			<th width={70} className="border">{uBahasaObj.caption_jmlnota||"Jml Nota"}</th>
			<th width={110} className="border">Vaksin<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Periksa<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Klinis<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Non Klinis<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Penitipan<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Grooming<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Transport<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Obat<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Barang<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">Lainnya<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">(Diskon)<small className="d-block">(Rp)</small></th>
			<th width={120} className="border">
				<div className="d-flex justify-content-center align-items-center">
				<div>
					{uBahasaObj.word_jumlah||"Jumlah"}
					<small className="d-block">(Rp)</small>
				</div>
				<CLink onClick={()=>{
						if((uSortedObj.field||"")!=="nilai_jumlah") 
							setSortedObj({ field: "nilai_jumlah",mode:"ASC" })
						else {
							if(uSortedObj.mode===undefined) uSortedObj.mode = "ASC";
							else if(uSortedObj.mode==="ASC") uSortedObj.mode = "DESC";
							else setSortedObj({});
						}
						setEfekview(!uEfekview);
					}}
					className={"ms-1 classcursorpointer "+((uSortedObj.field||"")==="nilai_jumlah"?"text-danger":"text-primary")}>
					<CIcon icon={((uSortedObj.mode||"")==="DESC"?"cilArrowBottom":"cilArrowTop")} className="align-middle" height={20}/>
				</CLink>
				</div>
			</th>
			<th width={110} className="border">PYAD HTPS<small className="d-block">(Rp)</small></th>
			<th width={110} className="border">PYAD JPL<small className="d-block">(Rp)</small></th>
			<th width={130} className="border">
				<div className="d-flex justify-content-center align-items-center">
				<div>
					JML (Piutang)
					<small className="d-block">(Rp)</small>
				</div>
				<CLink onClick={()=>{
						if((uSortedObj.field||"")!=="nilai_jumlah_2") 
							setSortedObj({ field: "nilai_jumlah_2",mode:"ASC" })
						else {
							if(uSortedObj.mode===undefined) uSortedObj.mode = "ASC";
							else if(uSortedObj.mode==="ASC") uSortedObj.mode = "DESC";
							else setSortedObj({});
						}
						setEfekview(!uEfekview);
					}}
					className={"ms-1 classcursorpointer "+((uSortedObj.field||"")==="nilai_jumlah_2"?"text-danger":"text-primary")}>
					<CIcon icon={((uSortedObj.mode||"")==="DESC"?"cilArrowBottom":"cilArrowTop")} className="align-middle" height={20}/>
				</CLink>
				</div>
			</th>
			</tr>
		)//>
	}
	const contentItemheaderfixed = () => {
		if(uHTMLError500) return "";
		/*//--CAT--/
		1. isi thead harus sama dengan Tabel Item utama
		//--END CAT--*/

		let vLeftpos = 0;
		if(uSidebarshow) {
			if(!uSidebarUnfoldable) vLeftpos = uSidebar.offsetWidth;
			else vLeftpos = 64;
		}

		return (
		<div className={"px-2 px-lg-4"+(uISShowtheadfixed?"":" d-none")} 
			style={{
				position:"fixed",top:uHeaderpageheight,left:vLeftpos,
				width:document.documentElement.clientWidth-vLeftpos,zIndex:1000}}>
		<div ref={fixedElementRef} 
			style={{overflowX:"auto",width:"auto",scrollbarWidth:"none",msOverflowStyle:"none",}}
			className=""
			id="iddivtabelfixed">
		<table
			style={{width:uTablewidth}}
			className="table mx-auto table-hover my-0" 
			id="idtabelfixed">
		<thead>{contentThead()}</thead>
		</table>
		</div>
		</div>
		)//>
	}
	const contentMain = () => {
		if(uHTMLError500) return "";

		if(uJmlData <= 0) return (
		<div className="text-center my-2 my-lg-5">
			<big className="fst-italic text-primary">
			{uBahasaObj.pesan_dataempty||"Data dengan Filter yang Dipilih Tidak Ditemukan.."}
			</big>
		</div>
		)//>

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;

		const vColspan		= 18;
		
		const vDataviewArr	= uDataviewArr.slice(vMin,(vMax));

		return (
		<div style={{overflowX: "auto"}} ref={scrollContainerRef} id="iddivtabel">
		<table ref={tableRef} 
			style={{width:uTablewidth}}
			className="table mx-auto table-borderless table-striped table-hover" id="idtabeldata">
			<thead ref={headerRef}>
			{contentThead()}
			</thead>

			<tbody>
			{vDataviewArr.map((vItems,vKeys) => {
				const {
					customer_id,customer_caption,jml_nota,
					nilai_vaksin,nilai_periksa,nilai_klinis,nilai_nonklinis,nilai_penitipan,
					nilai_grooming,nilai_transport,nilai_obat,nilai_barang,nilai_lainnya,
					nilai_pyad_htps,nilai_pyad_jpl,
					nilai_diskon,nilai_jumlah,nilai_jumlah_2,
				} = vItems;

				vNumber++;

				return (
				<tr className="align-top" key={vKeys}>
				<td className="px-1 text-end" style={uStylekolfixed}>{vNumber}.</td>
				<td className="px-1 text-start" style={{...uStylekolfixed,left:35}}>{(customer_caption||"Undf")}</td>
				
				<td className="text-center px-1"><small className="fw-bolder">{UFunc.formatAngka(jml_nota)}</small></td>

				<td className={"text-end px-1"+((parseFloat(nilai_vaksin)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_vaksin)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_vaksin))}
					{(parseFloat(nilai_vaksin)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_periksa)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_periksa)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_periksa))}
					{(parseFloat(nilai_periksa)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_klinis)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_klinis)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_klinis))}
					{(parseFloat(nilai_klinis)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_nonklinis)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_nonklinis)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_nonklinis))}
					{(parseFloat(nilai_nonklinis)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_penitipan)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_penitipan)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_penitipan))}
					{(parseFloat(nilai_penitipan)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_grooming)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_grooming)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_grooming))}
					{(parseFloat(nilai_grooming)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_transport)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_transport)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_transport))}
					{(parseFloat(nilai_transport)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_obat)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_obat)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_obat))}
					{(parseFloat(nilai_obat)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_barang)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_barang)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_barang))}
					{(parseFloat(nilai_barang)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_lainnya)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_lainnya)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_lainnya))}
					{(parseFloat(nilai_lainnya)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_diskon)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_diskon)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_diskon))}
					{(parseFloat(nilai_diskon)||0) < 0 && ")"}
				</td>

				<td className="text-end px-1 text-success">{UFunc.formatAngka(nilai_jumlah)}</td>

				<td className={"text-end px-1"+((parseFloat(nilai_pyad_htps)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_pyad_htps)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_pyad_htps))}
					{(parseFloat(nilai_pyad_htps)||0) < 0 && ")"}
				</td>

				<td className={"text-end px-1"+((parseFloat(nilai_pyad_jpl)||0)<0?" text-danger":"")}>
					{(parseFloat(nilai_pyad_jpl)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(nilai_pyad_jpl))}
					{(parseFloat(nilai_pyad_jpl)||0) < 0 && ")"}
				</td>

				<td className="text-end px-1 text-success">{UFunc.formatAngka(nilai_jumlah_2)}</td>
				</tr>
				)
			})}
			</tbody>

			<tfoot className="border-top border-top-primary">
			<tr className="fw-bolder text-white bg-dark">
				<td colSpan={2}  style={{...uStylekolfixed}} className="text-center bg-dark">JUMLAH</td>
				<td className="text-center"/>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_vaksin)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_vaksin)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_vaksin))}
					{(parseFloat(uDataloadedObj.sum_nilai_vaksin)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_periksa)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_periksa)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_periksa))}
					{(parseFloat(uDataloadedObj.sum_nilai_periksa)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_klinis)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_klinis)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_klinis))}
					{(parseFloat(uDataloadedObj.sum_nilai_klinis)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_nonklinis)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_nonklinis)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_nonklinis))}
					{(parseFloat(uDataloadedObj.sum_nilai_nonklinis)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_penitipan)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_penitipan)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_penitipan))}
					{(parseFloat(uDataloadedObj.sum_nilai_penitipan)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_grooming)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_grooming)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_grooming))}
					{(parseFloat(uDataloadedObj.sum_nilai_grooming)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_transport)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_transport)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_transport))}
					{(parseFloat(uDataloadedObj.sum_nilai_transport)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_obat)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_obat)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_obat))}
					{(parseFloat(uDataloadedObj.sum_nilai_obat)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_barang)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_barang)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_barang))}
					{(parseFloat(uDataloadedObj.sum_nilai_barang)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_lainnya)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_lainnya)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_lainnya))}
					{(parseFloat(uDataloadedObj.sum_nilai_lainnya)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_diskon)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_diskon)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_diskon))}
					{(parseFloat(uDataloadedObj.sum_nilai_diskon)||0) < 0 && ")"}
				</td>

				<td className="text-end text-success">{UFunc.formatAngka(uDataloadedObj.sum_nilai_jumlah)}</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_pyad_htps)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_pyad_htps)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_pyad_htps))}
					{(parseFloat(uDataloadedObj.sum_nilai_pyad_htps)||0) < 0 && ")"}
				</td>

				<td className={"text-end"+((parseFloat(uDataloadedObj.sum_nilai_pyad_jpl)||0)<0?" text-danger":"")}>
					{(parseFloat(uDataloadedObj.sum_nilai_pyad_jpl)||0) < 0 && "("}
					{UFunc.formatAngka(Math.abs(uDataloadedObj.sum_nilai_pyad_jpl))}
					{(parseFloat(uDataloadedObj.sum_nilai_pyad_jpl)||0) < 0 && ")"}
				</td>

				<td className="text-end text-success">{UFunc.formatAngka(uDataloadedObj.sum_nilai_jumlah_2)}</td>
			</tr>
			</tfoot>
		</table>
		</div>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSettingsystemObj.jml_tahun_laporan)||5;

		return (
		<CForm>
		<CRow className="my-2 mx-0">
		<CCol>Periode</CCol>
		<CCol md="8">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				className="w-auto"
				value={uDlgformObj.bln_id}
				onChange={(e)=>{uDlgformObj.bln_id=e.target.value; setEfekview(!uEfekview)}}
				id="inpbulanid">
			{cBulanPanjang.map((vItems,vKeys)=>{
				return (
				<option value={vKeys+1} key={vKeys}>{vItems.toUpperCase()}</option>
				)
			})}
			</CFormSelect>
			
			<span className="mx-1">&nbsp;</span>

			<CFormSelect size="sm"
				className="w-auto"
				value={uDlgformObj.tahun}
				onChange={(e)=>{uDlgformObj.tahun=e.target.value; setEfekview(!uEfekview)}}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inptahun">
				{(() => {
					let vTmpArr 	= [];
					const vTahunnow	= (new Date()).getFullYear();
					for(var vIdx=0;vIdx < vJmlTahunlaporan;vIdx++) {
						vTmpArr.push(
						<option value={(vTahunnow - vIdx)} key={vIdx}>{(vTahunnow - vIdx)}</option>
						)
					}
					return vTmpArr;
				})()}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		</CRow>
		
		</CForm>
		)//>
	}
	const contentHTMLcetak = () => {
		let vHTMLs	= uHTMLstyleTabel;

		//console.log("(Lappyad - contentHTMLcetak) uDataidentitasObj => "+(uDataidentitasObj));

		const vColspan 		= 18;
		const vDataviewArr	= uDataviewArr;

		vHTMLs	+= UFunc.RenderTabel(uDataidentitasObj,vColspan);
		
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			" (Pendapatan Yg Akan Diterima)";
		const vJudulsub		= `
			<div>Periode <b>`+uTitelObj.periode+`</b></div>
		`;

		const vTabelheader	= `
			<th width="3%" class="">No</th>
			<th align="left" class="">`+(uBahasaObj.word_customer||"Customer")+`</th>
			<th width="3%" class="classfontsmaller">`+(uBahasaObj.caption_jmlnota||"Jml Nota")+`</th>
			<th width="7%" class="classfontsmaller">Vaksin <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Periksa <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Klinis <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Non Klinis <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Penitipan <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Grooming <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Transport <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Obat <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Barang <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">Lainnya <small>(Rp)</small></th>
			<th width="%" class="classfontsmaller">(Diskon) <small>(Rp)</small></th>
			<th width="8%" class="classfontsmaller">Jumlah <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">(PYAD HTPS) <small>(Rp)</small></th>
			<th width="7%" class="classfontsmaller">PYAD JPL <small>(Rp)</small></th>
			<th width="8%" class="classfontsmaller">Piutang <small>(Rp)</small></th>
		`;
		
		let vTabelbody	= "";
		let vNumber		= 0;
		vDataviewArr.map((vItems,vKeys) => {
			const {
				id,customer_caption,jml_nota,nilai_jumlah,
				nilai_vaksin,nilai_periksa,nilai_klinis,nilai_nonklinis,nilai_penitipan,
				nilai_grooming,nilai_transport,nilai_obat,nilai_barang,nilai_lainnya,
				nilai_diskon,nilai_pyad_htps,nilai_pyad_jpl,nilai_jumlah_2
			} = vItems;
			vNumber++;

			vTabelbody += `
				<tr valign="top" key=`+vKeys+`>
				<td align="right">`+vNumber+`.</td>
				<td align="left">`+(customer_caption||"Undf")+`</td>
				<td align="center">`+UFunc.formatAngka(jml_nota)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_vaksin)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_periksa)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_klinis)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_nonklinis)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_penitipan)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_grooming)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_transport)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_obat)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_barang)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_lainnya)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_diskon)+`</td>
				<td align="right"><b>`+UFunc.formatAngka(nilai_jumlah)+`</b></td>
				<td align="right">`+UFunc.formatAngka(nilai_pyad_htps)+`</td>
				<td align="right">`+UFunc.formatAngka(nilai_pyad_jpl)+`</td>
				<td align="right"><b>`+UFunc.formatAngka(nilai_jumlah_2)+`</b></td>
				</tr>
			`;
		}).join("");
		
		const vTabelfooter 	= `
			<td colspan="3">JUMLAH</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_vaksin)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_periksa)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_klinis)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_nonklinis)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_penitipan)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_grooming)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_transport)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_obat)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_barang)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_lainnya)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_diskon)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_jumlah)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_pyad_htps)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_pyad_jpl)+`</td>
			<td align="right">`+UFunc.formatAngka(uDataloadedObj.sum_nilai_jumlah_2)+`</td>
		`;

		vHTMLs 		= vHTMLs.replace(/_TITELSUB_/g,vJudulsub);
		vHTMLs 		= vHTMLs.replace(/_JUDULLAPORAN_/g,vJudullaporan);
		vHTMLs 		= vHTMLs.replace(/_TABELHEADER_/g,vTabelheader);
		vHTMLs 		= vHTMLs.replace(/_TABELBODY_/g,vTabelbody);
		vHTMLs 		= vHTMLs.replace(/_TABELFOOTER_/g,vTabelfooter);

		return vHTMLs;
	}
	const contentExcel = () => {
		const vBulanID	= parseInt((uDataloadedObj||{}).bln_id)||"0";
		const vTahun	= parseInt((uDataloadedObj||{}).tahun)||"0";

		const vColspan 	= 18;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 10;

		let vTmpObj	= {
			no : "",
			customer_caption: "",
			jml_nota: "",
			nilai_vaksin: "",
			nilai_periksa: "",
			nilai_klinis: "",
			nilai_nonklinis: "",
			nilai_penitipan: "",
			nilai_grooming: "",
			nilai_transport: "",
			nilai_obat: "",
			nilai_barang: "",
			nilai_lainnya: "",
			nilai_diskon: "",
			nilai_jumlah: "",
			nilai_pyad_htps: "",
			nilai_pyad_jpl: "",
			nilai_jumlah_2: "",
		}
		vDatasetsArr.push(vTmpObj);
		vRowcount++;

		//console.log("uDataviewArr => "+JSON.stringify(uDataviewArr));
		uDataviewArr.map((vItems,vKeys)=>{
			const {
				id,customer_caption,jml_nota,nilai_vaksin,nilai_periksa,nilai_klinis,nilai_nonklinis,
				nilai_penitipan,nilai_grooming,nilai_transport,nilai_obat,nilai_barang,
				nilai_lainnya,nilai_diskon,nilai_jumlah,nilai_pyad_htps,nilai_pyad_jpl,
				nilai_jumlah_2,
			} = vItems;

			vColposwidth = (customer_caption||"").length > vColposwidth 
				? (customer_caption||"").length : vColposwidth; 

			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				customer_caption: (customer_caption||"Undf"),
				jml_nota: { v:parseInt(jml_nota||"0"), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
				nilai_vaksin: { v:parseFloat(nilai_vaksin||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_periksa: { v:parseFloat(nilai_periksa||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_klinis: { v:parseFloat(nilai_klinis||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_nonklinis: { v:parseFloat(nilai_nonklinis||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_penitipan: { v:parseFloat(nilai_penitipan||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_grooming: { v:parseFloat(nilai_grooming||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_transport: { v:parseFloat(nilai_transport||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_obat: { v:parseFloat(nilai_obat||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_barang: { v:parseFloat(nilai_barang||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_lainnya: { v:parseFloat(nilai_lainnya||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_diskon: { v:parseFloat(nilai_diskon||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_jumlah: { v:parseFloat(nilai_jumlah||"0"), t:"n", s:{numFmt: "#,##0",font:{bold:true}} },
				nilai_pyad_htps: { v:parseFloat(nilai_pyad_htps||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_pyad_jpl: { v:parseFloat(nilai_pyad_jpl||"0"), t:"n", s:{numFmt: "#,##0"} },
				nilai_jumlah_2: { v:parseFloat(nilai_jumlah_2||"0"), t:"n", s:{numFmt: "#,##0",font:{bold:true}} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "JUMLAH",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			customer_caption: "",
			jml_nota: "",
			nilai_vaksin: { v:parseFloat(uDataloadedObj.sum_nilai_vaksin)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_periksa: { v:parseFloat(uDataloadedObj.sum_nilai_periksa)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_klinis: { v:parseFloat(uDataloadedObj.sum_nilai_klinis)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_nonklinis: { v:parseFloat(uDataloadedObj.sum_nilai_nonklinis)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_penitipan: { v:parseFloat(uDataloadedObj.sum_nilai_penitipan)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_grooming: { v:parseFloat(uDataloadedObj.sum_nilai_grooming)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_transport: { v:parseFloat(uDataloadedObj.sum_nilai_transport)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_obat: { v:parseFloat(uDataloadedObj.sum_nilai_obat)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_barang: { v:parseFloat(uDataloadedObj.sum_nilai_barang)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_lainnya: { v:parseFloat(uDataloadedObj.sum_nilai_lainnya)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_diskon: { v:parseFloat(uDataloadedObj.sum_nilai_diskon)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_jumlah: { v:parseFloat(uDataloadedObj.sum_nilai_jumlah)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_pyad_htps: { v:parseFloat(uDataloadedObj.sum_nilai_pyad_htps)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_pyad_jpl: { v:parseFloat(uDataloadedObj.sum_nilai_pyad_jpl)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
			nilai_jumlah_2: { v:parseFloat(uDataloadedObj.sum_nilai_jumlah_2)||0, t:"n", s:{numFmt: "#,##0",font:{bold:true} } },
		};

		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:47}]
		const wscols	= [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:65},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:90},
			{wpx:100},
			{wpx:90},
			{wpx:90},
			{wpx:100},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 1 - 15}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_Lappyad_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+"_"+vTahun+
		"";
		const vSheetlabel = (cBulanPendek[vBulanID-1])+vTahun;

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);
		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+uTitelObj.periode+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Customer",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Jml Nota",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Vaksin (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Periksa (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Klinis (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.NONKlinis (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Penitipan (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Grooming (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Transport (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Obat (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Barang (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Lainnya (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Diskon (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Jumlah (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.PYAD HTPS (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.JPL (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"N.Piutang (Rp)",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/
		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//---END CONTENT--/

	//---API--/
	const apiLoadinit = () => {
		setHTMLError500(); 
		setDataloadedObj();
		setSortedObj({});
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_laphtps/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			//console.log("(Lappyad-apiLoadinit) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				//console.log("(Lappyad-apiLoadinit) output_string.dataidentitas : "+(output_string.dataidentitas));
				setDataidentitasObj(JSON.parse(output_string.dataidentitas || "{}"));
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lappyad-apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lappyad-apiLoadinit) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadview = () => {
		const vElsimpan	= document.getElementById("btnDialogSimpan");
		setDataloadedObj();
		setDatavieworiArr([]);
		setSortedObj({});
		
		setPageActive(1);
		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		
		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parjson: JSON.stringify(uDlgformObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lappyad/ld_view";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			//console.log("(Lappyad-apiLoadview) output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vTmpArr = (JSON.parse(output_string.datalaporan || "[]"));
				setDatavieworiArr([{firstrow:1},...vTmpArr]);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);

				setDataloadedObj(uDlgformObj);
				hdlDlgformToggle();
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lappyad-apiLoadview) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Lappyad - apiLoadview) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		apiLoadinit();

		window.addEventListener('scroll', handleScrollwindow);

		return () => {
			setShowtheadfixed(false);
			uDispatch({type: "set", gInitHeaderAction: {}});
			hdlDlgformToggle();
			setDataloadedObj(false);
			setDatavieworiArr([]);
			setSortedObj({});
			setDataidentitasObj({});
			setJmlData(0);setJmlHal(0);

			window.removeEventListener('scroll', handleScrollwindow);
		}
	},[])
	React.useEffect(()=>{ setTabelRowSelect(-1); },[uPageActive]);
	React.useEffect(()=>{
		const vDatadefaultArr = uDatavieworiArr.slice(1);
		setDataviewArr(vDatadefaultArr);
	},[uDatavieworiArr,uDatavieworiArr.length])
	React.useEffect(()=>{
		setJmlData(uDataviewArr.length);
		if(!uDataloadedObj) return;

		uDataloadedObj.sum_nilai_vaksin = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_vaksin||"0")
		}, 0);
		uDataloadedObj.sum_nilai_periksa = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_periksa||"0")
		}, 0);
		uDataloadedObj.sum_nilai_klinis = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_klinis||"0")
		}, 0);
		uDataloadedObj.sum_nilai_nonklinis = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_nonklinis||"0")
		}, 0);
		uDataloadedObj.sum_nilai_penitipan = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_penitipan||"0")
		}, 0);
		uDataloadedObj.sum_nilai_grooming = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_grooming||"0")
		}, 0);
		uDataloadedObj.sum_nilai_transport = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_transport||"0")
		}, 0);
		uDataloadedObj.sum_nilai_obat = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_obat||"0")
		}, 0);
		uDataloadedObj.sum_nilai_barang = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_barang||"0")
		}, 0);
		uDataloadedObj.sum_nilai_lainnya = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_lainnya||"0")
		}, 0);
		uDataloadedObj.sum_nilai_diskon = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_diskon||"0")
		}, 0);
		uDataloadedObj.sum_nilai_jumlah = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_jumlah||"0")
		}, 0);
		uDataloadedObj.sum_nilai_pyad_htps = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_pyad_htps||"0")
		}, 0);
		uDataloadedObj.sum_nilai_pyad_jpl = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_pyad_jpl||"0")
		}, 0);
		uDataloadedObj.sum_nilai_jumlah_2 = uDataviewArr.reduce((vNilaistored,vItems)=>{
			return vNilaistored + parseFloat(vItems.nilai_jumlah_2||"0")
		}, 0);
	},[uDataviewArr,uDataviewArr.length])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/

		if(!uElJmldata) return;
		initJmldata();
	},[uElJmldata,uJmlData]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500) return;

		const vTanggalnowDT	= new Date();
		if(uDlgformObj.bln_id === undefined)
			uDlgformObj.bln_id = uDataloadedObj ? uDataloadedObj.bln_id : vTanggalnowDT.getMonth()+1;
		if(uDlgformObj.tahun === undefined)
			uDlgformObj.tahun = uDataloadedObj ? uDataloadedObj.tahun : vTanggalnowDT.getFullYear();

		uDlgformObj.header = "Pilih Filter Laporan";
		setDlgformshow(true);
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderReset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500 || !uDataloadedObj) apiLoadinit()
		else { setDatavieworiArr([]);setDataviewArr([]); setDataloadedObj(); }
	},[uHandelReset]);
	React.useEffect(()=>{
		const vElfilter	= document.getElementById("btnFilter");
		if(!uISDlgformshow) { 
			vElfilter && (vElfilter.disabled = false)
			setDlgformObj({}); return 
		}

		vElfilter && (vElfilter.disabled = true)
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(isMobile) return;

			const vElfocus = document.getElementById("inpbulanid");
			vElfocus && vElfocus.focus();
		},350);
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uDataloadedObj) { setTitelObj({}); return }

		uTitelObj.periode 	= cBulanPanjang[parseInt(uDataloadedObj.bln_id)-1]+" "+uDataloadedObj.tahun;
	},[uDataloadedObj]);
	React.useEffect(()=>{
		if(uJmlData <= 0) return;

		const scrollContainer 	= (scrollContainerRef.current);
		const fixedContainer 	= (fixedElementRef.current);

		//console.log("(Lappyad - [scrollContainerRef,fixedElementRef]) scrollContainerRef exists:", scrollContainer);
		//console.log("(Lappyad - [scrollContainerRef,fixedElementRef]) fixedContainer exists:", fixedContainer);

		if(scrollContainer)
			scrollContainer.addEventListener('scroll', handleScrolltabel);
		if(fixedContainer)
			fixedContainer.addEventListener('scroll', handleScrolltabelfixed);

		return () => {
			setShowtheadfixed(false);

			scrollContainer && (scrollContainer.removeEventListener('scroll', handleScrolltabel));
			fixedContainer && (fixedContainer.removeEventListener('scroll', handleScrolltabelfixed));
		}
	},[uJmlData,scrollContainerRef,fixedElementRef]);
	React.useEffect(()=>{
		if(uDatavieworiArr.length <= 0) return;

		if(uPageActive > 1) setPageActive(1);
		else { setTabelRowSelect(-1); setTabelIDPilih(0); }

		if(UFunc.isEmpty(uSortedObj)) { 
			const vDatadefaultArr = uDatavieworiArr.slice(1);
			setDataviewArr(vDatadefaultArr);
			return
		}

		if(uSortedObj.mode==="ASC") {
			uDataviewArr.sort((a,b)=> a[uSortedObj.field] - b[uSortedObj.field])
		} else if(uSortedObj.mode==="DESC") {
			uDataviewArr.sort((a,b)=> b[uSortedObj.field] - a[uSortedObj.field])
		}
	},[uSortedObj,
	uSortedObj.field,
	uSortedObj.mode
	]);
	
	//console.log("Lappyad - uActiveroute => "+(uActiveroute));

	if(UFunc.isEmpty(uTokenObj)) { 
		setLoading(true); 
		prosesExpired(); 
		return (<></>)//>
	}
	if(uHTMLError500) return ( <MyPage500 content={uHTMLError500}/> )//>

	return (
	<>
		{contentItemheaderfixed()}
		{(!uDataloadedObj) ? (
		<CCard className="classcardbg">
			<CCardHeader className="">
			<small className="fw-bolder">Pilih Filter Laporan</small>
			</CCardHeader>

			<CCardBody className="d-flex justify-content-center align-items-center" style={{minHeight:200}}>
			<div className="classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<>
		<CCard className="classcardbg" id="idcardmain">
			<CCardHeader className="d-flex justify-content-between">
			<div>
			<div className="">Periode <b>{uTitelObj.periode}</b></div>
			{uTitelObj.subtitel && (
				<span className="text-primary classfontsmaller"><small>{uTitelObj.subtitel}</small></span>
			)}
			</div>

			<div>
				<CLink onClick={()=>hdlKlikCetak()} className="classcursorpointer classikon classikoncetak"/>
				<span className="mx-1">&middot;</span>
				<CLink onClick={()=>hdlKlikExcel()} className="classcursorpointer classikon classikonexcel"/>
				<span className="mx-1">&middot;</span>
				<span className="classfontsmaller">
					<small className="text-muted">
						{UFunc.formatAngka(uTimeElapsed)}ms
					</small>
				</span>
			</div>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{((uJmlData > uMaxData)) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>
		</>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.header}
			toggle={hdlDlgformToggle}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
	</>
	)//>
}	

export default Lappyad